import { AppSpecifier, RowWithEmbeddedMetadata } from "@data-root/types";
import { Skeleton, Space, Typography, Image } from "antd";
import { View, useTableHeaders } from "@data-root/react";
import { FC } from "react";

interface PreviewProps {
  appSpecifier: AppSpecifier;
  tableId: string;
  rowId: string;
  row: RowWithEmbeddedMetadata;

  loaded?: boolean;
}

const { Title, Text } = Typography;

export const PreviewSkeleton: FC = () => {
  return (
    <Space direction="vertical">
      <div
        style={{
          width: "100%",
          aspectRatio: 1,
        }}
      >
        <Skeleton.Image active />
      </div>

      <Skeleton.Input style={{ width: 100 }} active />
      <Skeleton active />
    </Space>
  );
};

export const Preview: FC<PreviewProps> = ({
  appSpecifier,
  tableId,
  rowId,
  row,
}) => {
  const { primaryHeader, secondaryHeader, imageUri } = useTableHeaders(
    appSpecifier,
    tableId,
    row
  );

  return (
    <View>
      {!!imageUri && (
        <Image
          style={{
            width: "100%",
            aspectRatio: 1,
            objectFit: "cover",
          }}
          src={imageUri}
        />
      )}

      {!!primaryHeader && <Title level={3}>{primaryHeader}</Title>}

      {!!secondaryHeader && <Title level={4}>{secondaryHeader}</Title>}

      <Text key="created">Created at {row.$metadata.created}</Text>
      <Text key="updated">Updated at {row.$metadata.updated}</Text>
    </View>
  );
};
